export default "__VITE_ASSET__luIbVgjFebxSBdyBGllgvw__"